import React, { Component } from 'react';
import axios from 'axios';
import { Configurations } from '../../../Utils/Configurations';
import moment from 'moment';
import {
    Modal, ModalBody, ModalHeader, ModalFooter, Button,
    TabContent, TabPane, Nav, NavItem, NavLink
} from "reactstrap";
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';
import { SingleDatePicker } from 'react-dates';
import ModalAlteracoes from '../../../Components/Modal-Alteracoes/Modal-Alteracoes';
import Usuario from '../../../Utils/Usuario';
import CardHighlightDetails from '../../../Components/Card-Highlight-Details/Card-Highlight-Details';
import ImagesUpload from '../../../Components/Images-Upload/Images-Upload';
import DivPermission from '../../../Components/Div-Permission/Div-Permission';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import Geral from '../../../Utils/Geral';




class VideosEpisodeDetails extends Component {

    constructor(props) {
        super(props);
        this.apiEpisodio = this.apiEpisodio.bind(this);
        this.salvarAlteracoes = this.salvarAlteracoes.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.mudaStatusEpisodio = this.mudaStatusEpisodio.bind(this);
        this.toggleSucessoAlteracao = this.toggleSucessoAlteracao.bind(this);
        this.habilitaSalvar = this.habilitaSalvar.bind(this);
        this.toggleModalPendencia = this.toggleModalPendencia.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.togglePub = this.togglePub.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
        this.formataDuracao = this.formataDuracao.bind(this);
        this.voltar = this.voltar.bind(this);
        this.toggleModalAlteracoes = this.toggleModalAlteracoes.bind(this);
        this.selecionarAba = this.selecionarAba.bind(this);
        this.chamarApiEstatisticaVideo = this.chamarApiEstatisticaVideo.bind(this);
        this.exibeDestaque = this.exibeDestaque.bind(this);
        this.scrollToElement = this.scrollToElement.bind(this);
        this.atualizaTags = this.atualizaTags.bind(this);
        this.handleSelectPeriodicos = this.handleSelectPeriodicos.bind(this);
        this.setDefaultValuePeriodico = this.setDefaultValuePeriodico.bind(this);
        this.carregaListaTags = this.carregaListaTags.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.pesoManual = this.pesoManual.bind(this);

        this.state = {
            isLoadingEpisodio: false,
            isLoadingAlteracoes: false,
            isLoadingStatus: false,
            novoEpisodio: this.props.match.params.idVideoEpisodio === "novo-episodio",
            temAlteracao: false,
            tags: [],
            habilitaSalvar: false,
            modalPendencia: false,
            pendencias: [],
            hasError: false,
            errorMessage: '',
            verificacaoAcesso: false,
            nomeEpisodio: '',
            descricaoEpisodio: '',
            urlImagem: '',
            videoId: '',
            idNivelAcesso: 3,
            dtPubAux: null,
            abaSelecionada: '1',
            isLoadingEstatistica: true,
            flagApiEstatisticaVideo: false,
            tituloDestaque: '',
            descricaoDestaque: '',
            isLoadingDestaque: false,
            openModalImagemDestaque: false,
            flagDestaqueBSMais: false,
            flagDestaqueHub: false,
            listaTags: [],
            listaTagsSelecionadas: [],
            isLoadingListaTags: false,
            pesoManualVideo: null
        }

        this.opcoesPeriodicos = [
            { label: "BS", value: 1 },
            { label: "TC", value: 3 },
            { label: "RD", value: 4 }
        ]

        this.Configurations = new Configurations();
    }
    componentWillUnmount() {
        // if (!window.location.href.includes(`conteudo/${this.props.match.params.periodico}`)) Session.clearInfos();
    }

    componentWillMount() {
        let _permissoes = [1, 4, 10, 14, 20];
        const roles = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const found = roles.some(r => _permissoes.indexOf(r) >= 0);
        const foundStatistic = roles.some(r => [24].indexOf(r) >= 0);

        if (!found && !foundStatistic) {
            this.props.history.push({ pathname: '/permissao-negada' });
        }
        else {
            this.setState({
                episodio: {
                    idVideoPrograma: this.props.match.params.idVideoPrograma
                },
                verificacaoAcesso: true,
                nomeMidia: "Vídeos",
                permissaoEdicaoVideo: found
            })
        }

        this.carregaListaTags();

    }

    componentDidMount() {
        // this.setState({ isLoadingEpisodio: true });
        if (this.state.verificacaoAcesso) {
            if (!this.state.novoEpisodio) {
                this.apiEpisodio();
            }
            else this.setState({
                // nomeEpisodio: '',
                // descricaoEpisodio: '',
                // urlImagem: '',
                // videoId: '',
                // idNivelAcesso: 3,
                isLoadingEpisodio: false
            })
        }
    }

    handleOnChange(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value, temAlteracao: true })

    }

    habilitaSalvar() {
        const _nomeValido = this.state.nomeEpisodio.trim() !== '';
        const _dtPubValida = !!this.state.dtPubAux;

        const _infosObrigatorias = [
            { campo: "Nome", valido: _nomeValido },
            { campo: "Data de Publicação", valido: _dtPubValida },
        ];

        const _pendencias = _infosObrigatorias.filter(item => !item.valido);

        this.setState({ habilitaSalvar: _nomeValido * _dtPubValida }, () => this.salvarAlteracoes(_pendencias))
    }

    salvarAlteracoes(_pend) {
        if (this.state.habilitaSalvar) {
            const _salvarEpisodio = {
                ...this.state.episodio,
                nome: this.state.nomeEpisodio,
                descricao: this.state.descricaoEpisodio,
                dtPublicacao: moment(this.state.dtPubAux).format(),
                idNivelAcesso: this.state.idNivelAcesso,
                videoId: this.state.videoId,
                imagem: this.state.urlImagem,
                tags: this.state.tags.map(item => item.label),
                imagemAlt: this.state.imagemAlt,
                metaTitle: this.state.metaTitle,
                metaDescription: this.state.metaDescription,
                periodico: this.state.opcaoPeriodicos,
                pesoManual: parseInt(this.state.pesoManualVideo) || 0
            }
            this.setState({ episodio: _salvarEpisodio, isLoadingAlteracoes: true }, () => {
                const { idVideoEpisodio, idVideoPrograma } = this.state.episodio;
                if (this.state.novoEpisodio) {
                    axios.post(this.Configurations.apiBasePath + `/videos/${idVideoPrograma}/episodios`, _salvarEpisodio).then(response => {
                        this.toggleSucessoAlteracao();
                    }).catch(this.handleError).finally(() => this.setState({ isLoadingAlteracoes: false }));
                } else {
                    axios.put(this.Configurations.apiBasePath + `/videos/${idVideoPrograma}/episodios/${idVideoEpisodio}`, _salvarEpisodio).then(response => {
                        this.toggleSucessoAlteracao();
                    }).catch(this.handleError).finally(() => this.setState({ isLoadingAlteracoes: false }));
                }
            })

        } else {
            this.setState({ pendencias: _pend }, () => this.toggleModalPendencia());
        }

    }

    mudaStatusEpisodio(metodo) {
        const { idVideoEpisodio, idVideoPrograma } = this.state.episodio;
        this.setState({ isLoadingStatus: true });
        axios.post(this.Configurations.apiBasePath + `/videos/${idVideoPrograma}/episodios/${idVideoEpisodio}/${metodo}`).then(response => {
            this.setState({ isLoadingStatus: false })
            this.apiEpisodio();
        }).catch(this.handleError);
    }

    apiEpisodio() {
        const { idVideoEpisodio, idVideoPrograma } = this.props.match.params;
        this.setState({ isLoadingEpisodio: true });
        axios.get(this.Configurations.apiBasePath + `/videos/${idVideoPrograma}/episodios/${idVideoEpisodio}`).then(response => {
            const _episodio = response.data.videosEpisodios[0];
            this.setState({
                episodio: _episodio,
                nomeEpisodio: _episodio.nome,
                descricaoEpisodio: _episodio.descricao,
                urlImagem: _episodio.imagem,
                videoId: _episodio.videoId,
                idNivelAcesso: _episodio.nivelAcesso.idNivelAcesso,
                dtPubAux: _episodio.dtPublicacao,
                flagDestaqueBSMais: _episodio.destaqueBSMais,
                flagDestaqueHub: _episodio.destaqueHub,
                tituloDestaqueBSMais: _episodio.destaqueBSMais ? undefined : _episodio.nome,
                tituloDestaqueHub: _episodio.destaqueHub ? undefined : _episodio.nome,
                descricaoDestaqueBSMais: _episodio.destaqueBSMais ? undefined : _episodio.descricao,
                descricaoDestaqueHub: _episodio.destaqueHub ? undefined : _episodio.descricao,
                imagemDestaqueBSMais: _episodio.destaqueBSMais ? undefined : _episodio.imagem,
                imagemDestaqueHub: _episodio.destaqueHub ? undefined : _episodio.imagem,
                idDestaqueBSMais: _episodio.idDestaqueBSMais,
                idDestaqueHub: _episodio.idDestaqueHub,
                exibeDestaqueBSMais: _episodio.destaqueBSMais,
                exibeDestaqueHub: _episodio.destaqueHub,
                tags: _episodio.tags.map((item, index) => {
                    return { label: item, value: item }
                }),
                imagemAlt: _episodio.imagemAlt,
                metaTitle: _episodio.metaTitle,
                metaDescription: _episodio.metaDescription,
                periodico: _episodio.periodico,
                pesoManualVideo: _episodio.pesoManual,

            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingEpisodio: false }));
    }

    toggleSucessoAlteracao() {
        if (this.state.modalSucessoAlteracao) {
            this.setState({ modalSucessoAlteracao: false }, () =>
                window.history.go(-1)
            );
        } else this.setState({ modalSucessoAlteracao: true })
    }

    toggleModalPendencia() {
        this.setState({ modalPendencia: !this.state.modalPendencia })
    }

    handleRadio(e) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleError(err) {
        // this.setState({ hasError: true, errorMessage: err.response.data.message })
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.message : 'Erro inesperado.' })
    }
    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    onDateChange(date) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({ dtPubAux: date })
    }

    togglePub() { this.setState({ modalPub: !this.state.modalPub }) }

    _outsideRange(day) {
        // return day.format() <= moment().format();
    }

    onChangeInput(e) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        const _name = e.target.name;
        this.setState({ [_name]: e.target.value });
        if (_name === 'pesoVideo') {
            this.setState({ pesoManualVideo: e.target.value });
        }
    }

    formataDuracao() {
        const _minutos = Math.floor(this.state.episodio.duracao / 60);
        const _segundos = this.state.episodio.duracao - _minutos * 60;
        return `${_minutos}min ${_segundos}s`;
    }

    voltar() {
        this.state.temAlteracao ? this.toggleModalAlteracoes() : window.history.go(-1)
    }

    toggleModalAlteracoes() {
        this.setState({ modalAlteracoes: !this.state.modalAlteracoes })
    }

    selecionarAba(tabe) {
        this.setState({ abaSelecionada: tabe })
        if (tabe === '2' && this.state.flagApiEstatisticaVideo === false) {
            this.chamarApiEstatisticaVideo();

        }
    }

    chamarApiEstatisticaVideo() {
        this.setState({ isLoadingEstatistica: true });
        axios.get(this.Configurations.apiBasePath + `/videos/${this.props.match.params.idVideoPrograma}
        /episodios/${this.props.match.params.idVideoEpisodio}/estatistica`)
            .then(response => {
                this.setState({
                    flagApiEstatisticaVideo: true,
                    estatisticasVideo: response.data.data
                });
            })
            .catch(this.handleError)
            .finally(() => this.setState({ isLoadingEstatistica: false }));
    }

    exibeDestaque(plataforma) {
        this.setState({ ['exibeDestaque' + plataforma]: true }, () => this.scrollToElement('informacoesDestaque' + plataforma))
    }

    scrollToElement(id) {
        var element = document.getElementById(id);
        if (!!element) element.scrollIntoView({ block: "end", behavior: "smooth" });
    }

    atualizaTags(_tags) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({ tags: _tags })
    }

    handleSelectPeriodicos(e, _name, o = null) {
        if (o && o.action === "clear") {
            this.setState({ [o.name]: null, temAlteracao: true });
            return;
        }
        this.setState({ [_name]: { value: e.value, label: e.label }, temAlteracao: true })
    }

    setDefaultValuePeriodico() {
        const periodicoSelecionado = this.opcoesPeriodicos.filter(item => item.label === this.state.periodico)
        if (periodicoSelecionado.length > 0) {
            return periodicoSelecionado[0]
        } else {
            return null
        }
    }

    carregaListaTags() {
        this.setState({ isLoadingListaTags: true })
        axios.get(this.Configurations.apiBasePath + `/tags`).then(response => {
            const _tagsOptions = response.data.data.map(item => ({
                label: item.nomeTag, value: item.nomeTag
            }))
            this.setState({ listaTags: _tagsOptions })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingListaTags: false }))
    }

    handleSelectChange(e, o) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true })
        let _list = this.state.tags;

        switch (o.action) {
            case "remove-value":
                const _index = _list.findIndex(item => item === o.removedValue);
                _list.splice(_index, 1);
                break;
            case "clear":
                _list = [];
                return o;
            default:
                _list.push(o.option);
                break;
        }
        this.setState({ tags: _list });
        return o;
    }

    pesoManual() {
        const pesos = [
            {
                peso: 0,
                nome: 'Não recomendado',
                input: 'peso0'
            },
            {
                peso: 1,
                nome: 'Nível 1',
                input: 'peso1'
            },
            {
                peso: 2,
                nome: 'Nível 2',
                input: 'peso2'
            },
            {
                peso: 3,
                nome: 'Nível 3',
                input: 'peso3'
            },
            {
                peso: 4,
                nome: 'Nível 4',
                input: 'peso4'
            },
            {
                peso: 5,
                nome: 'Nível 5',
                input: 'peso5'
            },
        ];

        return pesos
    }


    render() {
        return (
            <div className="row episode-details">
                <div className="div-video-episodio text-center w-100">
                    <Nav tabs>
                        <NavItem className="d-none d-lg-block">
                            <NavLink className={this.state.abaSelecionada === '1' ? 'classe-ativada-video' : 'classe-inativa-video'} onClick={() => { this.selecionarAba('1'); }}>
                                Editar vídeo
                            </NavLink>
                        </NavItem>
                        <NavItem className="d-none d-lg-block">
                            <NavLink className={this.state.abaSelecionada === '2' ? 'classe-ativada-video' : 'classe-inativa-video'} onClick={() => { this.selecionarAba('2'); }}>
                                Estatísticas do vídeo
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.abaSelecionada} className="w-100">
                        <TabPane tabId="1">
                            <div className="col-12">
                                {this.state.isLoadingEpisodio ? (
                                    <div className="row no-gutters">
                                        <div className="col-12 text-center py-5">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="row">
                                        <div className="col-12 col-lg-10 text-lg-left px-3 mt-3 mt-lg-3">
                                            <h3 className="d-none d-lg-block">{this.state.nomeMidia} - {this.state.novoEpisodio ? 'Novo Episódio' : `Episódio "${this.state.nomeEpisodio}"`}</h3>
                                            <h5 className="d-lg-none">{this.state.nomeMidia} - {this.state.novoEpisodio ? 'Novo episódio' : 'Episódio'}</h5>
                                            {!this.state.novoEpisodio && <h6 className="d-lg-none">"{this.state.nomeEpisodio}"</h6>}

                                        </div>
                                        <div className="col-12 col-lg-2 text-lg-right px-3 mt-lg-3 py-2">
                                            <button onClick={this.voltar} className="btn btn-outline-secondary">voltar</button>
                                        </div>
                                        {/* Layout desktop */}
                                        <div className="col-12 d-none d-lg-block">
                                            <div className="row no-gutters">
                                                <div className="col-4 py-3 text-left">
                                                    <small><small>(*)</small> informações obrigatórias</small>
                                                </div>
                                                {!this.state.isLoadingDestaqueBSMais && !this.state.isLoadingDestaqueHub && !this.state.novoEpisodio && (
                                                    <DivPermission
                                                        arrayPerm={[1, 20]}
                                                        permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                                    >
                                                        <div className="col-8 text-right py-3">
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="row">
                                                                        <div className="col-6 text-center">
                                                                            <div className="row">
                                                                                <div className="col-12 text-center">
                                                                                    {this.state.flagDestaqueBSMais && (
                                                                                        <span className="badge badge-verdeBM badge-destaque">Esse item é um destaque BS+</span>
                                                                                    )}
                                                                                </div>
                                                                                <div className="col-12 mt-3 text-center">
                                                                                    {this.state.permissaoEdicaoVideo && (
                                                                                        <button className="btn btn-outline-success" type="button" name="cadastrar-destaque" onClick={() => this.exibeDestaque("BSMais")}>{this.state.flagDestaqueBSMais ? 'editar destaque' : 'cadastrar como destaque BS+'}</button>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-6 text-center">
                                                                            <div className="row">
                                                                                <div className="col-12 text-center">
                                                                                    {this.state.flagDestaqueHub && (
                                                                                        <span className="badge badge-purple badge-destaque">Esse item é um destaque HUB</span>
                                                                                    )}
                                                                                </div>
                                                                                <div className="col-12 mt-3 text-center">
                                                                                    {this.state.permissaoEdicaoVideo && (
                                                                                        <button className="btn btn-outline-success" type="button" name="cadastrar-destaque" onClick={() => this.exibeDestaque("Hub")}>{this.state.flagDestaqueHub ? 'editar destaque' : 'cadastrar como destaque HUB'}</button>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </DivPermission>
                                                )}
                                            </div>
                                        </div>
                                        {/* Layout mobile */}
                                        <div className="col-12 d-lg-none">
                                            <div className="row no-gutters">
                                                {!this.state.isLoadingDestaqueBSMais && !this.state.isLoadingDestaqueHub && !this.state.novoEpisodio && (
                                                    <DivPermission
                                                        arrayPerm={[1, 20]}
                                                        permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                                    >
                                                        <div className="col-12 text-center">
                                                            <div className="row my-3">
                                                                <div className="col-6 text-center">
                                                                    <div className="row">
                                                                        {this.state.flagDestaqueBSMais && (
                                                                            <div className="col-12 text-center">
                                                                                <span className="badge badge-verdeBM badge-destaque">Destaque BS+</span>
                                                                            </div>
                                                                        )}
                                                                        <div className="col-12 text-center my-2 pr-1">
                                                                            <button className="btn btn-sm btn-outline-success" type="button" name="cadastrar-destaque" onClick={() => this.exibeDestaque("BSMais")}>{this.state.flagDestaqueBSMais ? 'editar' : 'cadastrar destaque BS+'}</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-6 text-center">
                                                                    <div className="row">
                                                                        {this.state.flagDestaqueHub && (
                                                                            <div className="col-12 text-center">
                                                                                <span className="badge badge-purple badge-destaque">Destaque HUB</span>
                                                                            </div>
                                                                        )}
                                                                        <div className="col-12 text-center pl-1 my-2">
                                                                            <button className="btn btn-sm btn-outline-success" type="button" name="cadastrar-destaque" onClick={() => this.exibeDestaque("Hub")}>{this.state.flagDestaqueHub ? 'editar' : 'cadastrar destaque HUB'}</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </DivPermission>
                                                )}
                                                <div className="col-12 text-left">
                                                    <small><small>(*)</small> informações obrigatórias</small>
                                                </div>
                                            </div>

                                        </div>

                                        <div className="col-12">
                                            <div className="row">
                                                <div className="col-12 col-lg-8">
                                                    <fieldset disabled={!this.state.permissaoEdicaoVideo}>
                                                        <div className="row">
                                                            <div className="col-12 col-lg-12 py-2 py-lg-3 text-left">
                                                                <label>Nome<sup><small>(*)</small></sup></label>
                                                                <input name="nomeEpisodio" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.nomeEpisodio} autoComplete="off" />
                                                            </div>
                                                            <div className="col-12 col-lg-12 py-3 text-left">
                                                                <label>Descrição</label>
                                                                <input name="descricaoEpisodio" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.descricaoEpisodio} autoComplete="off" />
                                                            </div>
                                                            <div className="col-12 col-lg-12 py-3 text-left">
                                                                <label>Url para a imagem de capa</label>
                                                                <input name="urlImagem" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.urlImagem} autoComplete="off" />
                                                            </div>
                                                            <div className="col-6 col-lg-4 py-3 text-left">
                                                                <label>Video ID <small>(vimeo)</small></label>
                                                                <input name="videoId" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.videoId} autoComplete="off" />
                                                            </div>
                                                            <div className="col-6 col-lg-3 py-3 text-center text-lg-left">
                                                                <label>Duração</label>
                                                                {((this.state.episodio.videoId !== this.state.videoId) || this.state.novoEpisodio) ? (
                                                                    <p className="mt-1 mb-0"><small><i>A ser calculada</i></small></p>
                                                                ) : (
                                                                    <p className="mt-1 mb-0"><small>{this.formataDuracao()}</small></p>
                                                                )}

                                                            </div>
                                                            <div className="offset-0 col-12 offset-lg-0 col-lg-5 py-3 text-lg-left text-center">
                                                                <div className="row">
                                                                    <div className="col-12 col-lg-12">
                                                                        <label>Data de Publicação<sup><small>(*)</small></sup></label>
                                                                    </div>
                                                                    <div className="col-12 col-lg-12">
                                                                        <SingleDatePicker
                                                                            isDisabled={!this.state.permissaoEdicaoVideo}
                                                                            date={this.state.dtPubAux !== null ? moment(this.state.dtPubAux) : null} // momentPropTypes.momentObj or null
                                                                            onDateChange={date => this.onDateChange(date)} // PropTypes.func.isRequired
                                                                            focused={this.state.focused} // PropTypes.bool
                                                                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                                                                            id="your_unique_id" // PropTypes.string.isRequired,
                                                                            orientation="horizontal"
                                                                            anchorDirection="left"
                                                                            openDirection="down"
                                                                            verticalHeight={450}
                                                                            numberOfMonths={1}
                                                                            small={true}
                                                                            phrases={this._phrases}
                                                                            placeholder=""
                                                                            displayFormat="DD/MM/YY"
                                                                            isOutsideRange={this._outsideRange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </fieldset>

                                                </div>
                                                <div className="col-12 col-lg-4">
                                                    <div className="row no-gutters">
                                                        <div className="col-12 py-1">
                                                            <div className="row no-gutters align-items-center">
                                                                <div className="col-12 text-center py-3">
                                                                    <div className="div-img-capa" style={{ backgroundImage: `url(${this.state.urlImagem})` }} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {this.state.isLoadingListaTags ? (
                                                    <div className="col-12 text-center px-3">
                                                        <div className="spinner-border text-primary " role="status" />
                                                    </div>
                                                ) : (
                                                    <div className="col-6 col-lg-7 py-3 text-left d-none d-lg-block tags-videos-episodios">
                                                        <div className='form-group'>
                                                            <label htmlFor="tags-videos-episodios">Tags</label>
                                                            <Select
                                                                id="tags-videos-episodios"
                                                                isDisabled={!this.state.permissaoEdicaoVideo}
                                                                placeholder=""
                                                                closeMenuOnSelect={true}
                                                                defaultValue={this.state.tags}
                                                                isMulti
                                                                name="tags"
                                                                onChange={this.handleSelectChange}
                                                                options={this.state.listaTags}

                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="col-12 col-lg-2 py-3 text-left">
                                                    <fieldset disabled={!this.state.permissaoEdicaoVideo}>
                                                        <label>Acesso</label>
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="radio" name="idNivelAcesso" id="excl" checked={parseInt(this.state.idNivelAcesso, 10) === 3} value={"3"} onChange={this.onChangeInput} />
                                                            <label className="form-check-label" htmlFor="excl">Exclusivo para assinantes</label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="radio" name="idNivelAcesso" id="assoc" checked={parseInt(this.state.idNivelAcesso, 10) === 2} value={"2"} onChange={this.onChangeInput} />
                                                            <label className="form-check-label" htmlFor="assoc">Aberto para associados</label>
                                                        </div>
                                                        {/* <div className="form-check">
                                                            <input className="form-check-input" type="radio" name="idNivelAcesso" id="nao-assoc" checked={parseInt(this.state.idNivelAcesso, 10) === 4} value={"4"} onChange={this.onChangeInput} />
                                                            <label className="form-check-label" htmlFor="assoc">Aberto para não associados logados</label>
                                                        </div> */}
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="radio" name="idNivelAcesso" id="publ" checked={parseInt(this.state.idNivelAcesso, 10) === 1} value={"1"} onChange={this.onChangeInput} />
                                                            <label className="form-check-label" htmlFor="publ">Aberto ao público</label>
                                                        </div>
                                                    </fieldset>
                                                </div>
                                                <div className="col-4 col-lg-3 py-3 text-left">
                                                    <label>Recomendação de vídeo</label>
                                                    <div className="form-check">
                                                        {this.pesoManual() && this.pesoManual().map(item => (
                                                            <div key={item.input}>
                                                                <input className="form-check-input" type="radio" name="pesoVideo" id={item.input} checked={parseInt(this.state.pesoManualVideo) === item.peso} value={item.peso} onChange={this.onChangeInput} />
                                                                <label className="form-check-label" htmlFor={item.input}>{item.nome}</label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="row no-gutters">
                                                        <div className="col-12 col-lg-3 text-left py-4">
                                                            <div className="form-group m-0">
                                                                <label htmlFor="periodicos">Vincular a um periódico: </label>
                                                                <Select
                                                                    isDisabled={!this.state.permissaoEdicaoVideo}
                                                                    id="periodicos"
                                                                    placeholder="Selecione um periódico"
                                                                    closeMenuOnSelect={true}
                                                                    components={makeAnimated()}
                                                                    options={this.opcoesPeriodicos}
                                                                    onChange={(e, o) => this.handleSelectPeriodicos(e, "opcaoPeriodicos", o)}
                                                                    name="opcaoPeriodicos"
                                                                    isClearable
                                                                    defaultValue={this.setDefaultValuePeriodico()}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* Mobile */}
                                                {this.state.isLoadingListaTags ? (
                                                    <div className="col-12 text-center px-3">
                                                        <div className="spinner-border text-primary " role="status" />
                                                    </div>
                                                ) : (
                                                    <div className="col-12 py-3 text-left tags-videos-episodios d-lg-none">
                                                        <div className='form-group'>
                                                            <label htmlFor="tags-videos-episodios">Tags</label>
                                                            <Select
                                                                isDisabled={!this.state.permissaoEdicaoVideo}
                                                                id="tags-videos-episodios"
                                                                placeholder=""
                                                                closeMenuOnSelect={true}
                                                                defaultValue={this.state.tags}
                                                                isMulti
                                                                name="tags"
                                                                onChange={this.handleSelectChange}
                                                                options={this.state.listaTags}

                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="col-12 text-left">
                                                    <label>Imagem alt</label>
                                                    <fieldset disabled={!this.state.permissaoEdicaoVideo}>
                                                        <input name="imagemAlt" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.imagemAlt} autoComplete="off" />
                                                    </fieldset>
                                                </div>
                                                <div className="col-12 text-left mt-3">
                                                    <label>Meta title</label>
                                                    <fieldset disabled={!this.state.permissaoEdicaoVideo}>
                                                        <input name="metaTitle" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.metaTitle} autoComplete="off" />
                                                    </fieldset>
                                                </div>
                                                <div className="col-12 text-left mt-3">
                                                    <label>Meta description</label>
                                                    <fieldset disabled={!this.state.permissaoEdicaoVideo}>
                                                        <input name="metaDescription" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.metaDescription} autoComplete="off" />
                                                    </fieldset>
                                                </div>
                                                <div className="col-12 py-3 text-lg-right text-center">
                                                    {this.state.temAlteracao && (
                                                        <p className="text-danger mb-2 mr-2"><i>As alterações ainda não foram salvas.</i></p>
                                                    )}
                                                    {this.state.isLoadingAlteracoes ? (
                                                        <div className="spinner-border text-primary" role="status" />
                                                    ) : (
                                                        <React.Fragment>
                                                            {this.state.permissaoEdicaoVideo && (
                                                                <button onClick={this.habilitaSalvar} disabled={!this.state.temAlteracao} className='btn btn-outline-success'>salvar alterações</button>
                                                            )}
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div >
                                )}
                            </div>
                            {this.state.exibeDestaqueBSMais && (
                                <DivPermission
                                    arrayPerm={[1, 20]}
                                    permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                >
                                    <div className="col-12">
                                        <div className="row mt-5 informacoes-destaque" id="informacoesDestaqueBSMais">
                                            <CardHighlightDetails
                                                tipoDestaque={4}
                                                idDestaque={this.state.idDestaqueBSMais}
                                                match={this.props.match}
                                                apiConteudo={this.apiEpisodio}
                                                plataforma={1}
                                                sigla={"VD"}
                                                itemConteudo={this.state.episodio}
                                                flagDestaque={this.state.flagDestaqueBSMais}
                                            />
                                        </div>
                                    </div>
                                </DivPermission>
                            )}
                            {this.state.exibeDestaqueHub && (
                                <DivPermission
                                    arrayPerm={[1, 20]}
                                    permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                >
                                    <div className="col-12">
                                        <div className="row mt-5 informacoes-destaque" id="informacoesDestaqueHub">
                                            <CardHighlightDetails
                                                tipoDestaque={4}
                                                idDestaque={this.state.idDestaqueHub}
                                                match={this.props.match}
                                                apiConteudo={this.apiEpisodio}
                                                plataforma={2}
                                                sigla={"VD"}
                                                itemConteudo={this.state.episodio}
                                                flagDestaque={this.state.flagDestaqueHub}
                                            />
                                        </div>
                                    </div>
                                </DivPermission>
                            )}
                        </TabPane>
                        <TabPane tabId="2">
                            <div className="col-12 px-3 py-3">
                                <div className="row">
                                    <div className="col-12 col-lg-10 text-center text-lg-left">
                                        <h3>Estatísticas do vídeo - {this.state.nomeEpisodio}</h3>
                                    </div>
                                    <div className="col-12 col-lg-2 text-center text-lg-right">
                                        <button onClick={this.voltar} className="btn btn-outline-secondary">voltar</button>
                                    </div>
                                </div>
                            </div>
                            {this.state.isLoadingEstatistica ? (
                                <div className="col-12 text-center px-3">
                                    <div className="spinner-border text-primary " role="status" />
                                </div>
                            ) : (
                                <div className="col-12 my-4">
                                    <div className="card">
                                        <div className="card-header">
                                            <strong>Resumo</strong>
                                        </div>
                                        <div className="card-body">
                                            {/* <Loading show={this.state.isLoading} /> */}
                                            <div className="row mb-4">
                                                <div className="col-12">
                                                    <div className="row text-center">
                                                        <div className="col-12 border-bottom pb-2">
                                                            <strong>Visualizações</strong>
                                                        </div>
                                                        <div className="col-12 pt-2">
                                                            <div className="row text-center">
                                                                <div className="col">
                                                                    <span className="featured-number">{this.state.estatisticasVideo.qtdMembrosAssistiram}</span><br />
                                                                    <span>{this.state.estatisticasVideo.qtdMembrosAssistiram > 1 ? 'Membros' : 'Membro'}</span>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mb-4 px-6">
                                                <div className="col-5">
                                                    <div className="row">
                                                        <div className="col-12 text-center border-bottom pb-2">
                                                            <strong>Coordenadorias</strong>
                                                        </div>
                                                        <div className="col-12 pt-2">

                                                            <table className="table table-borderless table-sm">
                                                                <tbody>
                                                                    {this.state.estatisticasVideo.qtdReproducoesCoordenadoria.map((coord, index) => {
                                                                        return (<tr key={index}>
                                                                            <td className="text-left">
                                                                                <strong className="text-uppercase">{coord.coordenadoria}: </strong>
                                                                            </td>
                                                                            <td className="text-right">{coord.qtdReproducao} <small>({Geral.validarNumero(Math.round(coord.qtdReproducao / this.state.estatisticasVideo.qtdReproducoes * 100))}%)</small></td>
                                                                        </tr>)
                                                                    })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="offset-2 col-5">
                                                    <div className="row">
                                                        <div className="col-12 text-center border-bottom pb-2">
                                                            <strong>Divisão</strong>
                                                        </div>
                                                        <div className="col-12 pt-2">

                                                            <table className="table table-borderless table-sm">
                                                                <tbody>
                                                                    {this.state.estatisticasVideo.qtdReproducoesDivisao.map((divisao, index) => {
                                                                        return (<tr key={index}>
                                                                            <td className="text-left">
                                                                                <strong className="">{divisao.divisao}: </strong>
                                                                            </td>
                                                                            <td className="text-right">{divisao.qtdReproducao} <small>({Geral.validarNumero(Math.round(divisao.qtdReproducao / this.state.estatisticasVideo.qtdReproducoes * 100))}%)</small></td>
                                                                        </tr>)
                                                                    })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-5">
                                                    <div className="row">
                                                        <div className="col-12 text-center border-bottom pb-2">
                                                            <strong>Função</strong>
                                                        </div>
                                                        <div className="col-12 pt-2">

                                                            <table className="table table-borderless table-sm">
                                                                <tbody>
                                                                    {this.state.estatisticasVideo.qtdReproducoesFuncao.map((func, index) => {
                                                                        return (<tr key={index}>
                                                                            <td className="text-left">
                                                                                <strong className="">{func.funcao}: </strong>
                                                                            </td>
                                                                            <td className="text-right">{func.qtdReproducao} <small>({Geral.validarNumero(Math.round(func.qtdReproducao / this.state.estatisticasVideo.qtdReproducoes * 100))}%)</small></td>
                                                                        </tr>)
                                                                    })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="offset-2 col-5">
                                                    <div className="row">
                                                        <div className="col-12 text-center border-bottom pb-2">
                                                            <strong>Idade</strong>
                                                        </div>
                                                        <div className="col-12 pt-2">

                                                            <table className="table table-borderless table-sm">
                                                                <tbody>
                                                                    {this.state.estatisticasVideo.qtdReproducoesIdade.map((idade, index) => {
                                                                        return (<tr key={index}>
                                                                            <td className="text-left">
                                                                                <strong className="">{idade.idade}: </strong>
                                                                            </td>
                                                                            <td className="text-right">{idade.qtdReproducao} <small>({Geral.validarNumero(Math.round(idade.qtdReproducao / this.state.estatisticasVideo.qtdReproducoes * 100))}%)</small></td>
                                                                        </tr>)
                                                                    })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-5">
                                                    <div className="row">
                                                        <div className="col-12 text-center border-bottom pb-2">
                                                            <strong>Data</strong>
                                                        </div>
                                                        <div className="col-12 pt-2">

                                                            <table className="table table-borderless table-sm">
                                                                <tbody>
                                                                    {this.state.estatisticasVideo.qtdReproducoesPorData.map((data, index) => {
                                                                        return (<tr key={index}>
                                                                            <td className="text-left">
                                                                                <strong className="">{data.dtReproducao}: </strong>
                                                                            </td>
                                                                            <td className="text-right">{data.qtdReproducao} <small>({Geral.validarNumero(Math.round(data.qtdReproducao / this.state.estatisticasVideo.qtdReproducoes * 100))}%)</small></td>
                                                                        </tr>)
                                                                    })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            )}
                        </TabPane>
                    </TabContent>
                </div>
                <Modal className="modal-upload-imagem" size="lg" isOpen={this.state.openModalImagemDestaque} toggle={this.toggleModalImagemDestaque}>
                    <ModalHeader toggle={this.toggleModalImagemDestaque}>
                        Upload de imagem - Destaque
                    </ModalHeader>
                    <ModalBody>
                        <ImagesUpload toggle={this.toggleModalImagemDestaque} onChangeInput={this.onChangeInputDestaque} />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.modalSucessoAlteracao} toggle={this.toggleSucessoAlteracao}>
                    <ModalHeader toggle={this.toggleSucessoAlteracao}>
                        {this.state.novoEpisodio ? 'Novo Episódio' : 'Edição de Episódio'}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.novoEpisodio ? 'Novo episódio criado com sucesso! :)' : 'Alterações realizadas com sucesso! :)'}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={this.toggleSucessoAlteracao}>ok</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalPendencia} toggle={this.toggleModalPendencia}>
                    <ModalHeader toggle={this.toggleModalPendencia}>Campos obrigatórios</ModalHeader>
                    <ModalBody>
                        <p>Por favor, preencha o(s) seguinte(s) campo(s) obrigatório(s):</p>
                        <ul>
                            {this.state.pendencias && this.state.pendencias.map((item, index) => {
                                return <li key={`campo-${index}`}>{item.campo}</li>
                            })}
                        </ul>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggleModalPendencia}>ok</Button>
                    </ModalFooter>
                </Modal>

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                // direcionaURL={'/conteudo'}
                // goBack={true}
                />
                {this.state.permissaoEdicaoVideo &&
                    <ModalAlteracoes
                        isOpen={this.state.modalAlteracoes}
                        toggle={this.toggleModalAlteracoes}
                    />
                }


            </div >
        )
    }
}

export default VideosEpisodeDetails;